import { API } from './Api';
import CONFIG from '../../config';

export class Auth extends API {

    login(login, password){
        
        return API.getInstance().post('/user/token', { login, password }).then((res) => {
            if(res.status === 200){
                API.getInstance().setToken(res.data);
                res.data = this.parseJwt(res.data)
                return res;
            }
            else
                throw new Error(res);
        })
    }

    parseJwt (token) {
        if(!token) return this.parseJwt(API.getInstance().getToken() || 'break');
        //avoid loop
        if(token === "break") return null;
        
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    };

    isValid() {
        const token = API.getInstance().getToken();

        if(!token) return false;
        
        try {
            if(this.parseJwt(token).exp > new Date().getTime()/1000)
                return true;
            else
                this.logout();
        } catch (e) {
            this.logout();
        }

        return false ;
    }

    logout(){
        API.getInstance().setToken(null);
    }

    register(args = {}){
        if(!args.login)
            args.login = args.email;
        
        return API.getInstance().post('/user', args).then((res) => {
            if(res.status === 200 || res.status === 201)
                return this.login(args.login, args.password)
            else
                throw new Error(res);
        })
    }

    sso(ticket) {
        return API.getInstance().post('/user/sso', { 
            ticket, 
            service: encodeURIComponent(CONFIG.SSO.service + (localStorage.getItem("ssoFromPresence") === "yes" ? "event/presence" : "")), 
            ssoUrl: CONFIG.SSO.url
        }).then((res) => {
            localStorage.removeItem("ssoFromPresence")
            if(res.status === 200){
                API.getInstance().setToken(res.data);
                res.data = this.parseJwt(res.data)
                return res;
            }
            else
                throw new Error(res);
        })
    }
}

export default new Auth();


// WEBPACK FOOTER //
// ./src/helper/api/Auth.js